var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlaytn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for Klaytn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4F473B",
    d: "m15.56 15.32 11.17-11.1L16.43 0 6.24 24.66l9.33-9.34ZM27.7 26.57 16.75 15.72 27.69 4.87a15.82 15.82 0 0 1 0 21.7ZM5.19 27.13l10.77-10.7 10.77 10.7-10.77 4.47-10.77-4.47ZM4.3 26.57A15.74 15.74 0 0 1 0 15.72L15 .8 4.3 26.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaytn);
export default __webpack_public_path__ + "static/media/klaytn.b6146769e664c69e0a45de7b3c06ef06.svg";
export { ForwardRef as ReactComponent };